import { type AnyAction, type AsyncThunk, createAction } from '@reduxjs/toolkit'

// biome-ignore lint: no-comment
type GenericAsyncThunk = AsyncThunk<unknown, unknown, any>

type PendingAction = ReturnType<GenericAsyncThunk['pending']>
type RejectedAction = ReturnType<GenericAsyncThunk['rejected']>
type FulfilledAction = ReturnType<GenericAsyncThunk['fulfilled']>

// eslint-disable-next-line
const actioneGenerator = (name: string) => {
  return {
    name,
    isPendingAction: (action: AnyAction): action is PendingAction => {
      return action.type.startsWith(name) && action.type.endsWith('/pending')
    },
    isRejectedAction: (action: AnyAction): action is RejectedAction => {
      return action.type.startsWith(name) && action.type.endsWith('/rejected')
    },
    isFulfilledAction: (action: AnyAction): action is FulfilledAction => {
      return action.type.startsWith(name) && action.type.endsWith('/fulfilled')
    },
    ResetAction: createAction(`${name}-reset-tracked-loading-state`)
  }
}

export type { FulfilledAction, GenericAsyncThunk, PendingAction, RejectedAction }
export default actioneGenerator
